import { queryClient } from "@/v1/utils/queryClient";

export const refetchAssetsQuery = () => queryClient.refetchQueries(["assets-query"]);
